/**
 * ciało w lsnBase
 */
angular.module('ihestiaCommonDirectives.validators', [
  'lsnBase.validators'
]);